import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from 'react-hot-toast';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ResourcesPage from './pages/ResourcesPage';
import PricingPage from './pages/PricingPage';
import AboutPage from './pages/AboutPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import DashboardPage from './pages/DashboardPage';
import AdminDashboard from './components/admin/dashboard/AdminDashboard';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import SuccessPage from './pages/SuccessPage';
import PromotionManager from './components/promotions/PromotionManager';
import LoadingScreen from './components/LoadingScreen';

function App() {
  // Add a listener for the "load" event to ensure all resources are loaded
  useEffect(() => {
    const handleLoad = () => {
      // Force a repaint after everything is loaded
      document.body.style.display = 'none';
      setTimeout(() => {
        document.body.style.display = '';
      }, 10);
    };

    window.addEventListener('load', handleLoad);
    return () => window.removeEventListener('load', handleLoad);
  }, []);

  return (
    <Router>
      <AuthProvider>
        <Toaster position="top-right" />
        <Suspense fallback={<LoadingScreen />}>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Layout><HomePage /></Layout>} />
            <Route path="/recursos" element={<Layout><ResourcesPage /></Layout>} />
            <Route path="/precos" element={<Layout><PricingPage /></Layout>} />
            <Route path="/sobre" element={<Layout><AboutPage /></Layout>} />
            <Route path="/login" element={<Layout><LoginPage /></Layout>} />
            <Route path="/cadastro" element={<Layout><SignupPage /></Layout>} />
            <Route path="/termos-de-servico" element={<Layout><TermsOfServicePage /></Layout>} />
            <Route path="/politica-de-privacidade" element={<Layout><PrivacyPolicyPage /></Layout>} />
            <Route path="/success" element={<SuccessPage />} />

            {/* Protected Dashboard Routes */}
            <Route path="/dashboard/*" element={
              <ProtectedRoute>
                <Suspense fallback={<LoadingScreen />}>
                  <DashboardPage />
                  <PromotionManager />
                </Suspense>
              </ProtectedRoute>
            } />

            {/* Admin Routes */}
            <Route path="/admin/*" element={
              <AdminRoute>
                <Suspense fallback={<LoadingScreen />}>
                  <AdminDashboard />
                </Suspense>
              </AdminRoute>
            } />

            {/* Catch-all route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </AuthProvider>
    </Router>
  );
}

export default App;